import React from 'react';

interface Props {
  value: number;
  setValue: React.Dispatch<React.SetStateAction<number>>;
}

export const PercentageSlider: React.FC<Props> = ({ setValue, value }) => {
  const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(parseInt(event.target.value));
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseInt(event.target.value);
    setValue(newValue >= 0 && newValue <= 100 ? newValue : value);
  };

  return (
    <div className="flex flex-col items-center ">
      <div className="relative mb-6 w-[3.75rem]">
        <input
          title="input percentage"
          type="text"
          inputMode="numeric"
          className="w-full py-1 pl-1.5  border border-gray-150 rounded text-center appearance-none"
          value={value}
          onChange={handleInputChange}
          style={{ paddingRight: '15px' }}
        />
        <span className="absolute inset-y-0 right-1.5 flex items-center text-gray-500">%</span>
      </div>
      <input
        title="input percentage"
        type="range"
        className="w-full h-1  appearance-none cursor-pointer bg-gray-100 slider-thumb"
        min="0"
        max="100"
        value={value}
        onChange={handleSliderChange}
        style={{ backgroundSize: `${value}% 100%` }}
      />
      <div className="flex flex-1 place-self-stretch justify-between mt-[0.5rem] ">
        <div className="text-sm text-gray-600 ">{`0%`}</div>
        <div className="text-sm text-gray-600 ">{`100%`}</div>
      </div>
    </div>
  );
};
